import { BrowserRouter } from 'react-router-dom';
import Footer from './components/Footer';
import AboutUs from './components/Sections/AboutUs';
import Faq from './components/Sections/Faq';
import Hero from './components/Sections/Hero';
import Download from './components/Sections/Download';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="page_wrepper">
        <Hero />
        <AboutUs />
        <Faq />
        <Download />
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
